<template>
  <div class="home">
    <head-com></head-com>
    <div class="main" v-loading="loading">
      <div class="personal">
        <div class="left">
          <span class="photo fl">
            <img
              v-if="userInfo.empHeadportrait"
              :src="userInfo.empHeadportrait"
              alt
            />
            <img v-else src="../assets/images/person.png" alt />
          </span>
          <div class="info fl">
            <h3 class="name">{{ userInfo.empName }}</h3>
            <p>电话: {{ userInfo.empTel }}</p>
            <p>身份证: {{ userInfo.empIdcard }}</p>
          </div>
        </div>
        <!-- <div class="right fr">
          <p class="line">学习时长</p>
          <h3 class="line">{{userTotalTime.userSturyTotalHourse}}</h3>
        </div>-->
      </div>
      <div class="tabs">
        <span :class="{ active: isActive == '' }" @click="getCourse('')"
          >全部</span
        >
        <span :class="{ active: isActive == '0' }" @click="getCourse('0')"
          >待学习</span
        >
        <span :class="{ active: isActive == '2' }" @click="getCourse('2')"
          >学习中</span
        >
        <span :class="{ active: isActive == '1' }" @click="getCourse('1')"
          >已学完</span
        >
      </div>
      <ul class="studyList cl">
        <router-link
          tag="li"
          :to="{
            path: '/detailList',
            query: { course: item.courseId, reg: item.regId },
          }"
          v-for="(item, i) in dataList"
          :key="i"
        >
          <div class="box bs cur">
            <span class="allreadyTime" v-if="item.diffDate >= 0"
              >有效期:{{ item.diffDate }}天</span
            >
            <span class="allreadyTimePass" v-else>已过期</span>
            <div class="img-wrap">
              <img :src="item.coursePic" alt />
            </div>
            <span class="suspension" v-if="item.suspensionType == 1">
              <img src="../assets/images/suspension.png" alt />
            </span>
            <h3 class="title ellipsis">{{ item.courseName }}</h3>
            <p class="glance">
              <span>课时: {{ item.courseTotalHours }}</span>
              <span class="view"
                >报名时间: {{ item.regDate.split(" ")[0] }}</span
              >
            </p>
          </div>
        </router-link>
      </ul>
      <!-- <div class="public" v-if="dataSure">
        <img src="../assets/images/public.png" alt />
      </div> -->
      <div class="img cl bs" v-if="dataSure">
        <div class="imgbox">
          <img src="../../static/examNull.png" alt />
          <p class="text">暂无课程哦</p>
        </div>
      </div>
      <el-dialog
        title="完善个人信息"
        :visible.sync="dialogVisible"
        width="500px"
        center
        class="personalPop"
      >
        <img src="../assets/images/tips.png" alt="" />
        <p>请完善个人信息并完成实名认证 后开始学习</p>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
    <footer-com></footer-com>
  </div>
</template>

<script>
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";
import http from "../api/module";

export default {
  name: "home",
  components: {
    HeadCom,
    FooterCom,
  },
  data() {
    return {
      loading: true,
      isActive: "",
      // tabsList: [{ title: "待学习" }, { title: "已学完" }, { title: "学习中" }],
      pageNum: "1", // 页码
      pageSize: "20", // 每页数量
      userTotalTime: {},
      userInfo: {},
      dataList: [],
      dataSure: false,
      dialogVisible: false,
      completions: undefined, // 0：完整 1：不完整
    };
  },
  mounted() {
    this.getCourse("");
    this.getAll();
    this.checkEmployeeInformation();
  },
  methods: {
    // 验证个人信息是否完整
    checkEmployeeInformation() {
      return http
        .checkEmployeeInformation({})
        .then((data) => {
          if (data.data.code == "200" || data.data.success == true) {
            this.completions = data.data.data.completions;
            if (
              !localStorage.getItem("dialogVisible") &&
              this.completions == 1
            ) {
              this.dialogVisible = true;
              localStorage.setItem("dialogVisible", true);
            }
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message,
            });
          }
        })
        .catch((error) => {
          // this.$message.error("请求失败!请联系管理员");
        });
    },
    // 获取课程列表
    getCourse(index) {
      this.isActive = index;
      return http
        .trainRecord({
          overStatus: index,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        })
        .then((data) => {
          if (data.data.code == "200" || data.data.success == true) {
            this.dataList = data.data.data;
            if (!this.dataList.length) {
              this.dataSure = true;
            } else {
              this.dataSure = false;
            }
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message,
            });
          }
        })
        .catch((error) => {
          // this.$message.error("请求失败!请联系管理员");
        });
    },
    async getAll() {
      try {
        // let time = http.getUserTime(); // 获取当前用户学习时长
        let info = http.getUserInfo(); // 获取当前用户信息
        let list = http.trainRecord({
          overStatus: this.isActive,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        });
        await Promise.all([info, list]).then((data) => {
          this.loading = false;
          // var dataTime = data[0].data;
          var dataUser = data[0].data;
          var infoList = data[1].data;
          // if (dataTime.code == "200" || dataTime.success == true) {
          //   this.userTotalTime = dataTime.data;
          // } else {
          //   this.$message.error({
          //     duration: 1000,
          //     message: dataTime.message
          //   });
          // }
          if (dataUser.code == "200" || dataUser.success == true) {
            this.userInfo = dataUser.data;
          } else {
            this.$message.error({
              duration: 1000,
              message: dataUser.message,
            });
          }
          if (infoList.code == "200" || infoList.success == true) {
            this.dataList = infoList.data;
          } else {
            this.$message.error({
              duration: 1000,
              message: infoList.message,
            });
          }
        });
      } catch (error) {
        this.$message.error({
          duration: 1000,
          message: "请求失败!请联系管理员",
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.allreadyTime {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 16px;
  line-height: 30px;
  width: 120px;
  text-align: center;
  height: 30px;
  color: #fff;
  background-color: #00ee76;
}
.allreadyTimePass {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 16px;
  line-height: 30px;
  width: 120px;
  text-align: center;
  height: 30px;
  color: #fff;
  background-color: #ff6347;
}
.loading {
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  z-index: 10;
}
.personal {
  width: 100%;
  background: #ffffff;
  box-shadow: 0 0 5px #cccccc;
  margin-top: 20px;
  border-radius: 6px;
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .photo {
    width: 80px;
    height: 80px;
    img {
      display: inline-block;
      border-radius: 50%;
      width: 100%;
      height: 100%;
    }
  }
  .info {
    margin-left: 20px;
    .name {
      font-size: 18px;
      line-height: 30px;
      font-weight: 600;
    }
    p {
      line-height: 26px;
    }
  }
  .line {
    line-height: 30px;
    font-weight: normal;
  }
  .right {
    text-align: center;
  }
}
.tabs {
  margin: 20px 0;
  span {
    padding: 6px 16px;
    background: #909399;
    color: #fff;
    margin-right: 10px;
    border-radius: 30px;
    font-size: 14px;
    cursor: pointer;
  }
  .active {
    background: #409eff;
  }
}
.studyList {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  &:after {
    content: "";
    flex: auto;
  }
  li {
    width: 23%;
    height: 250px;
    margin-bottom: 30px;
    margin-right: 30px;
    position: relative;
    &:nth-child(4n) {
      margin-right: 0;
    }
    .box {
      height: 100%;
      width: 100%;
      padding: 12px;
      background: #fff;
      border-radius: 4px;
      position: absolute;
      top: 0;
      transition: 0.3s;
      &:hover {
        box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
        top: -10px;
      }
    }
    .img-wrap {
      width: 100%;
      height: 160px;
      overflow: hidden;
      img {
        width: auto;
        height: 100%;
        min-width: 100%;
      }
    }
    .title {
      width: 100%;
      margin-top: 10px;
      line-height: 32px;
      font-weight: normal;
      font-size: 16px;
    }
    .view {
      margin-left: 20px;
    }
    .glance {
      font-size: 14px;
      color: #aaa;
    }
  }
}
.public {
  width: 100%;
  background: #fff;
  max-height: 450px;
  box-shadow: 0 0 5px rgb(228, 227, 227);
  position: relative;
  img {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
}
.img {
  width: 100%;
  // height: 100%;
  height: 450px;
  background: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
  position: relative;
  .imgbox {
    display: inline-block;
    position: absolute;
    top: 46%;
    left: 50%;
    transform: translate(-50%, -50%);

    .text {
      font-size: 26px;
      color: #666;
      position: absolute;
      left: 50%;
      bottom: 30px;
      transform: translateX(-50%);
    }
  }
}
.suspension {
  position: absolute;
  right: -6px;
  top: -6px;
}
.personalPop {
  img {
    display: block;
    max-width: 100%;
    height: 100px;
    margin: auto;
  }
  p {
    text-align: center;
    font-weight: 500;
    font-size: 18px;
    color: #666666;
    margin-top: 20px;
  }
}
</style>
